import { RootState } from "../reducers";

export const getMutationTypes = (state: RootState) => state.app.mutationTypes;
